export default function Section3() {
  return (
    <div className="Section3 mt-[2%] mb-[4%] md:my-0 px-5 md:px-0 md:pt-[2%]">
      <div className="flex flex-col md:items-center md:flex-row section3-container md:justify-evenly">
        <div className="md:w-[36%] md:mx-[2%]">
          <h1 className="text-[24px] leading-[32px] md:text-[34px] md:leading-[41px] font-bold text-[#DA2128] my-[0.67em] pb-[2%]">
            We Are Experts In Custom Plugin & App Development
          </h1>

          <p className="text-[16px] mb-5 leading-[20px] text-[#373737] font-open pb-[1%]">
            We provide custom plugin development services to enhance
            functionality of open-source software, CMS and shopping cart
            software.
          </p>

          <p className="text-[16px] mb-5 leading-[20px] text-[#373737] font-open pb-[1%]">
            Providing best quality plugins development services. Plugins are
            also called apps, extensions, addons or scripts.
          </p>
        </div>

        <div className="image-cont">
            <img src="../../../../assets/computer-image-plugin-app.png"></img>
        </div>
      </div>

      <div className="line my-[55px] md:my-[4%] mx-auto w-[70%] md:w-[61%] shadow-line h-2 rounded-[100%]"></div>
    </div>
  );
}
